import Joi from 'joi'
export const FormTwoSchema = Joi.object().keys({
    current_age: Joi.number().min(18).max(64).required().messages({
        'number.base': 'กรุณากรอกข้อมูล',
        'number.min': 'กรุณากรอกอายุระหว่าง 18 - 64 ปี',
        'number.max': 'กรุณากรอกอายุระหว่าง 18 - 64 ปี',
        'any.required': `กรุณากรอกข้อมูล`,
        'any.only': `กรุณากรอกข้อมูล`,
    }),
    retirement_age: Joi.number()
        .required()
        .greater(Joi.ref('current_age'))
        .messages({
            'number.base': 'กรุณากรอกข้อมูล',
            'any.required': `กรุณากรอกข้อมูล`,
            'number.greater': 'อายุเกษียณต้องมากกว่าอายุปัจจุบัน',
            'any.only': `กรุณากรอกข้อมูล`,
        }),
    years_before_retirement: Joi.number().required().messages({
        'number.base': 'กรุณากรอกข้อมูล',
        'any.required': `กรุณากรอกข้อมูล`,
        'any.only': `กรุณากรอกข้อมูล`,
    }),
    payment_after_retirement_each_month: Joi.number().required().messages({
        'number.base': 'กรุณากรอกข้อมูล',
        'any.required': `กรุณากรอกข้อมูล`,
        'any.only': `กรุณากรอกข้อมูล`,
    }),
    payment_after_retirement_each_year: Joi.number().required().messages({
        'number.base': 'กรุณากรอกข้อมูล',
        'any.required': `กรุณากรอกข้อมูล`,
        'any.only': `กรุณากรอกข้อมูล`,
    }),
})

export const FormThreeSchema = Joi.object().keys({
    long_term_inflation_assumption: Joi.number()
        .min(2)
        .max(3.5)
        .required()
        .messages({
            'number.base': 'กรุณากรอกข้อมูล',
            'number.min': 'กรุณากรอกระหว่าง 2.00% - 3.50% ต่อปี',
            'number.max': 'กรุณากรอกระหว่าง 2.00% - 3.50% ต่อปี',
            'any.required': `กรุณากรอกข้อมูล`,
            'any.only': `กรุณากรอกข้อมูล`,
        }),
    payment_at_retirement_first_year: Joi.number().required().messages({
        'number.base': 'กรุณากรอกข้อมูล',
        'any.required': `กรุณากรอกข้อมูล`,
        'any.only': `กรุณากรอกข้อมูล`,
    }),
    estimated_final_age: Joi.number().min(80).max(120).required().messages({
        'number.base': 'กรุณากรอกข้อมูล',
        'number.min': 'ไม่ควรต่ำกว่า 85 ปี',
        'number.max': 'ไม่ควรต่ำกว่า 120 ปี',
        'any.required': `กรุณากรอกข้อมูล`,
        'any.only': `กรุณากรอกข้อมูล`,
    }),
    amount_retirement_years: Joi.number().required().messages({
        'number.base': 'กรุณากรอกข้อมูล',
        'any.required': `กรุณากรอกข้อมูล`,
        'any.only': `กรุณากรอกข้อมูล`,
    }),
    estimated_rate_return_after_retirement: Joi.number()
        .min(2.5)
        .max(5)
        .required()
        .messages({
            'number.base': 'กรุณากรอกข้อมูล',
            'number.min': 'กรุณากรอกระหว่าง 2.50% - 5.00% ต่อปี',
            'number.max': 'กรุณากรอกระหว่าง 2.50% - 5.00% ต่อปี',
            'any.required': `กรุณากรอกข้อมูล`,
            'any.only': `กรุณากรอกข้อมูล`,
        }),
    rate_return_after_retirement_with_inflation: Joi.number()
        .required()
        .messages({
            'number.base': 'กรุณากรอกข้อมูล',
            'any.required': `กรุณากรอกข้อมูล`,
            'any.only': `กรุณากรอกข้อมูล`,
        }),
    required_funds_for_retirement: Joi.number().required().messages({
        'number.base': 'กรุณากรอกข้อมูล',
        'any.required': `กรุณากรอกข้อมูล`,
        'any.only': `กรุณากรอกข้อมูล`,
    }),
})

export const FormFourSchema = Joi.object().keys({
    quiz_id: Joi.number(),
    provident_fund: Joi.number().allow('').messages({
        'number.base': 'กรุณากรอกข้อมูล',
        'any.required': `กรุณากรอกข้อมูล`,
        'any.only': `กรุณากรอกข้อมูล`,
    }),
    assets_invested_to_reach_retirement_goal: Joi.number().allow('').messages({
        'number.base': 'กรุณากรอกข้อมูล',
        'any.required': `กรุณากรอกข้อมูล`,
        'any.only': `กรุณากรอกข้อมูล`,
    }),
    expected_rate_of_return_before_retirement: Joi.number()
        .required()
        .messages({
            'number.base': 'กรุณากรอกข้อมูล',
            'any.required': `กรุณากรอกข้อมูล`,
            'any.only': `กรุณากรอกข้อมูล`,
        }),
    estimated_saving_source_for_retirement: Joi.number().required().messages({
        'number.base': 'กรุณากรอกข้อมูล',
        'any.required': `กรุณากรอกข้อมูล`,
        'any.only': `กรุณากรอกข้อมูล`,
    }),
    social_security_fund: Joi.number().allow(0).messages({
        'number.base': 'กรุณากรอกข้อมูล',
    }),
    other_assets: Joi.number().allow(0).messages({
        'number.base': 'กรุณากรอกข้อมูล',
    }),
    life_insurance_mtl: Joi.boolean(),
    life_insurance_other: Joi.boolean(),
})

export const FormSevenSchema = Joi.object().keys({
    /*ques_1: Joi.number().required().messages({
        'number.base': 'กรุณาเลือกคำตอบ',
        'any.required': `กรุณาเลือกคำตอบ`,
        'any.only': `กรุณาเลือกคำตอบ`,
    }),
    ques_2: Joi.number().required().messages({
        'number.base': 'กรุณาเลือกคำตอบ',
        'any.required': `กรุณาเลือกคำตอบ`,
        'any.only': `กรุณาเลือกคำตอบ`,
    }),
    person_id: Joi.string().required().messages({
        'number.base': 'กรุณากรอกข้อมูล',
        'any.required': `กรุณากรอกข้อมูล`,
        'any.only': `กรุณากรอกข้อมูล`,
    }),
    person_type: Joi.number().required().messages({
        'number.base': 'กรุณากรอกข้อมูล',
        'any.required': `กรุณากรอกข้อมูล`,
        'any.only': `กรุณากรอกข้อมูล`,
    }),*/
})

export const FormContactSchema = Joi.object().keys({
    topic: Joi.string().required().messages({
        'string.base': 'กรุณากรอกข้อมูล',
        'string.empty': 'กรุณากรอกข้อมูล',
        'any.required': `กรุณากรอกข้อมูล`,
    }),
    email: Joi.string()
        .required()
        .max(255)
        .email({ tlds: { allow: false } })
        .messages({
            'string.base': `กรุณากรอกอีเมล`,
            'string.empty': `กรุณากรอกอีเมล`,
            'any.required': `กรุณากรอกอีเมล`,
            'string.min': `กรุณากรอกอีเมล`,
            'string.max': `อีเมลยาวเกินไป`,
            'string.email': `กรุณากรอกอีเมลให้ถูกต้อง เช่น example@gmail.com`,
        }),
    mobileno: Joi.string().required().messages({
        'string.base': 'กรุณากรอกข้อมูล',
        'string.empty': 'กรุณากรอกข้อมูล',
        'any.required': `กรุณากรอกข้อมูล`,
    }),
    firstname: Joi.string().required().messages({
        'string.base': 'กรุณากรอกข้อมูล',
        'string.empty': 'กรุณากรอกข้อมูล',
        'any.required': `กรุณากรอกข้อมูล`,
    }),
    lastname: Joi.string().required().messages({
        'string.base': 'กรุณากรอกข้อมูล',
        'string.empty': 'กรุณากรอกข้อมูล',
        'any.required': `กรุณากรอกข้อมูล`,
    }),
    disclosing: Joi.string().required().messages({
        'string.base': 'กรุณากรอกข้อมูล',
        'string.empty': 'กรุณากรอกข้อมูล',
        'any.required': `กรุณากรอกข้อมูล`,
    }),
    quiz_id: Joi.number(),
    pdf: Joi.any(),
    person_type: Joi.number(),
})
